import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import SideNav from "./sidenav";
import Header from "./header";
import { getBranchList } from "../redux/actions/branchAction";
import Back from "../assets/images/arrow2.png";

const BranchDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { branchList } = useSelector(
    (store) => store.branchReducer,
  );

  useEffect(() => {
    if (!branchList?.data?.result) {
      dispatch(getBranchList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const branch = branchList?.data?.result?.find((b) => b._id === id) || null;

  return (
    <>
      <Header />
      <SideNav />
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <div>
              <h4 className="Title">
                <Link to="/branch-management">
                  <img src={Back} alt="Back" />
                </Link>
                Branch Details
              </h4>
            </div>
          </div>

          <div className="Small-Wrapper">
            {!branch ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "300px",
                }}
              >
                <div
                  className="spinner-border text-primary"
                  role="status"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    color: "#003a6b",
                    marginBottom: "15px",
                  }}
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <h5 style={{ color: "#003a6b" }}>Loading branch details...</h5>
              </div>
            ) : (
              <div
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #eee",
                  borderRadius: "12px",
                  padding: "30px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
                }}
              >
                {/* Header Profile Section */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "24px",
                    borderBottom: "1px solid #f1f3f5",
                    paddingBottom: "25px",
                    marginBottom: "25px",
                  }}
                >
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundColor: "#f0f4f8",
                      borderRadius: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#003a6b",
                      fontWeight: "700",
                      fontSize: "28px",
                      overflow: "hidden",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    }}
                  >
                    {branch.logo ? (
                      <img
                        src={branch.logo}
                        alt={branch.storeName}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      branch.storeName?.substring(0, 2).toUpperCase() || "BR"
                    )}
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <h3
                        style={{
                          margin: 0,
                          fontSize: "22px",
                          fontWeight: "700",
                          color: "#333",
                        }}
                      >
                        {branch.storeName}
                      </h3>
                      <span
                        style={{
                          backgroundColor:
                            branch.status === "Active" ? "#e6f4ea" : "#fce8e6",
                          color:
                            branch.status === "Active" ? "#1e8e3e" : "#d93025",
                          padding: "4px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "600",
                        }}
                      >
                        {branch.status || "Active"}
                      </span>
                    </div>
                    <p
                      style={{
                        margin: "5px 0 0 0",
                        color: "#6c757d",
                        fontSize: "14px",
                      }}
                    >
                      Branch ID: {branch.storeNumber || branch._id}
                    </p>
                  </div>
                  <div>
                    <Link
                      to={`/branch-edit/${branch._id}`}
                      className="Button"
                      style={{
                        backgroundColor: "#003a6b",
                        color: "#fff",
                        padding: "10px 24px",
                        borderRadius: "6px",
                        fontWeight: "600",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        textDecoration: "none",
                        fontSize: "14px",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#002b50";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#003a6b";
                      }}
                    >
                      <i className="fa fa-pencil"></i> EDIT BRANCH
                    </Link>
                  </div>
                </div>

                {/* Details Grid */}
                <div className="row">
                  {/* Left Column: Contact & Manager Details */}
                  <div
                    className="col-md-6"
                    style={{ borderRight: "1px solid #f1f3f5" }}
                  >
                    <h5
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#003a6b",
                        marginBottom: "18px",
                      }}
                    >
                      General Info
                    </h5>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                      }}
                    >
                      <div>
                        <strong
                          style={{
                            display: "block",
                            fontSize: "12px",
                            color: "#999",
                            textTransform: "uppercase",
                          }}
                        >
                          Manager Name
                        </strong>
                        <span
                          style={{
                            fontSize: "15px",
                            color: "#333",
                            fontWeight: "500",
                          }}
                        >
                          {branch.managerName || "Not specified"}
                        </span>
                      </div>
                      <div>
                        <strong
                          style={{
                            display: "block",
                            fontSize: "12px",
                            color: "#999",
                            textTransform: "uppercase",
                          }}
                        >
                          Phone Number
                        </strong>
                        <span
                          style={{
                            fontSize: "15px",
                            color: "#333",
                            fontWeight: "500",
                          }}
                        >
                          {branch.mobileNumber || "Not specified"}
                        </span>
                      </div>
                      <div>
                        <strong
                          style={{
                            display: "block",
                            fontSize: "12px",
                            color: "#999",
                            textTransform: "uppercase",
                          }}
                        >
                          Login Email
                        </strong>
                        <span
                          style={{
                            fontSize: "15px",
                            color: "#333",
                            fontWeight: "500",
                          }}
                        >
                          {branch.email || "Not specified"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Right Column: Location Details */}
                  <div className="col-md-6" style={{ paddingLeft: "30px" }}>
                    <h5
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#003a6b",
                        marginBottom: "18px",
                      }}
                    >
                      Location Details
                    </h5>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                      }}
                    >
                      <div>
                        <strong
                          style={{
                            display: "block",
                            fontSize: "12px",
                            color: "#999",
                            textTransform: "uppercase",
                          }}
                        >
                          Address
                        </strong>
                        <span
                          style={{
                            fontSize: "15px",
                            color: "#333",
                            fontWeight: "500",
                          }}
                        >
                          {branch.address || "Not specified"}
                        </span>
                      </div>
                      <div>
                        <strong
                          style={{
                            display: "block",
                            fontSize: "12px",
                            color: "#999",
                            textTransform: "uppercase",
                          }}
                        >
                          City
                        </strong>
                        <span
                          style={{
                            fontSize: "15px",
                            color: "#333",
                            fontWeight: "500",
                          }}
                        >
                          {branch.city || "Not specified"}
                        </span>
                      </div>
                      <div style={{ display: "flex", gap: "30px" }}>
                        <div>
                          <strong
                            style={{
                              display: "block",
                              fontSize: "12px",
                              color: "#999",
                              textTransform: "uppercase",
                            }}
                          >
                            Latitude
                          </strong>
                          <span
                            style={{
                              fontSize: "15px",
                              color: "#333",
                              fontWeight: "500",
                            }}
                          >
                            {branch.lat ||
                              branch.location?.coordinates?.[1] ||
                              "N/A"}
                          </span>
                        </div>
                        <div>
                          <strong
                            style={{
                              display: "block",
                              fontSize: "12px",
                              color: "#999",
                              textTransform: "uppercase",
                            }}
                          >
                            Longitude
                          </strong>
                          <span
                            style={{
                              fontSize: "15px",
                              color: "#333",
                              fontWeight: "500",
                            }}
                          >
                            {branch.long ||
                              branch.location?.coordinates?.[0] ||
                              "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BranchDetails;
